import { spawn } from 'redux-saga/effects';

import { sagas as usages } from './usagesModule';
import { sagas as sso } from './ssoModule';

export default function* sagas() {
	yield spawn(usages);
	yield spawn(sso);
}
